export default {
  width: window.innerWidth,

  breakpoints: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  },

  init() {
    Object.entries(this.breakpoints).forEach(([name, px]) => {
      const mq = window.matchMedia(`(min-width: ${px}px)`);
      this[name] = mq.matches;
      mq.addEventListener('change', (e) => this[name] = e.matches);
    });

    window.addEventListener('resize', () => this.width = window.innerWidth);
  },

  get only() {
    return {
      sm: this.sm && !this.md,
      md: this.md && !this.lg,
      lg: this.lg && !this.xl,
      xl: this.xl && !this['2xl'],
      '2xl': this['2xl'],
    };
  },

  below(bp) { return !this[bp]; },
  above(bp) { return this[bp]; },
};
